import { axiosInstance } from '@/lib/utils';
import { endpoints } from '@/api';
import type { RequestResponse } from '@/types';
import type { Bank } from './response';

export const fetchBanks = async () => {
  const response = await axiosInstance<RequestResponse<Bank[]>>(
    endpoints.banks
  );
  return response.data.data;
};
